//@flow
import find from 'lodash/find'
import {type StoreState} from '$src/state/types'
import {type RequestNameSpaceState} from '$src/requests/types'
import {createApiErrorMessage} from '$util'

export const isFetching = (state: StoreState, requestKey?: string): boolean => {
  const requestsState: RequestNameSpaceState = state.requests
  if (requestKey) {
    return !!find(requestsState, request => requestKey === request.requestKey)
  } else {
    return !!Object.keys(requestsState).length
  }
}

export const selectApiErrorMessage = (
  state: StoreState
): void | Array<string> | string => {
  if (state.asyncError) {
    // $FlowIgnore
    return createApiErrorMessage(state.asyncError)
  }
}



// WEBPACK FOOTER //
// ./src/requests/selectors.js